const state = {
    labelsDefault: {
        area: {
            pk: 0,
            points: [],
            panorama: null,
            interactive_image: null,
            content_page: null,
        },
        hotspot: {
            pk: 0,
            x_coord: 100.0,
            y_coord: 100.0,
            panorama: null,
            interactive_image: null,
            content_page: null,
        },
        marker: {
            pk: 0,
            x_coord: 100.0,
            y_coord: 100.0,
            pointer_x_coord: 0.0,
            pointer_y_coord: 0.0,
            panorama: null,
            interactive_image: null,
            content_page: null,
            image: "",
            diameter: 100.0,
        },
        overlay: {
            pk: 0,
            x_coord: 100.0,
            y_coord: 100.0,
            pointer_x_coord: 0.0,
            pointer_y_coord: 0.0,
            panorama: null,
            interactive_image: null,
            content_page: null,
            width: 100,
            height: 100,
            image: ""
        },
        text: {
            pk: 0,
            x_coord: 200.0,
            y_coord: 100.0,
            pointer_x_coord: 0.0,
            pointer_y_coord: 0.0,
            panorama: null,
            interactive_image: null,
            content_page: null,
            text: "Sample Text",
        },
        xrayspot: {
            pk: 0,
            x_coord: 100.0,
            y_coord: 100.0,
            pointer_x_coord: 0.0,
            pointer_y_coord: 0.0,
            panorama: null,
            interactive_image: null,
            content_page: null,
            image: "",
            diameter: 100.0,
        },
        boundingzoom:{
            pk:0,
            x_coord:0,
            y_coord:0,
            width:100,
            height:100,
            panorama: null,
            interactive_image: null,
            content_page: null,
        }
    },
    
    defaultBaseImage:"/images/placeholder.png",
    
    defaultMedia:{
        "picture" :"/images/placeholder.png",
        "video" :"/images/placeholder.png",
        "text" :"/images/placeholder.png",
    },
    
    ongletColors : [
        '#378EF0',
        '#1da300',
        '#e74c3c',
        '#de80ff',
        '#e67e22',
        '#00a183',
        '#3472ff',
        '#9e8300',
        '#8d008d',
        '#af0069',
    ],
    
    delayBeforeDrag : 0
};

import Tools from "../../class/tools";

const getters = {
    labelsDefault: state => type => {
        return state.labelsDefault[type];
    },
    getDefault: state => name => {
        return Tools.clone(state["default"+name]);
    },
    getDefaultMedia: state => type => {
        return Tools.clone(state["defaultMedia"][type]);
    },
    getDelayBeforeDrag: state => state.delayBeforeDrag
};

const actions = {

};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}
